import { useContext, useEffect, useReducer } from "react";
import { AppContext, AppContextInterface } from "@/contexts/AppContext";

import translate from "@/i18n/translate";
import { Program } from "@/features/common/interfaces/Interface";
import { sendRequest } from "@/common/http";
import WidgetLoader from "@/features/common/elements/WidgetLoader";
import { ContributorInstitutionInsights } from "./ContributorInstitutionInsights";
import { ContributorOrganizationInsights } from "./ContributorOrganizationInsights";
import { ContributorProgramInsights } from "./ContributorProgramInsights";
import { checkIfSllProductIntegrated } from "@/features/common/helper";

interface State {
  nodeAccess: NodeAccess | null;
}
export interface Organization {
  name: string;
  code: string;
  type: string;
  uuid: string;
  institutionUuid: string;
}
export interface NodeAccess {
  institution: Organization[]
  organizations: Organization[];
  programs: Program[];
}
interface Action {
  type: string;
  nodeAccess: NodeAccess | null;
}

const defaultAction: Action = {
  type: "",
  nodeAccess: null
};

const stateReducer = (state: State, action: Action) => {
  switch (action.type) {
    case "setNodeAccess":
      return {
        ...state,
        nodeAccess: action.nodeAccess
      };
    default:
      return state;
  }
};

const initialState: State = {
  nodeAccess: null
};

export function ContributorInsights() {
  const [state, dispatch] = useReducer(stateReducer, initialState);
  const { sysUser, integratedProducts, institution } =
    useContext<AppContextInterface>(AppContext);
  const isAdminUser = sysUser?.roles.includes("administrator");
  useEffect(() => {
    if (!isAdminUser) {
      const applyResult = (result: NodeAccess) => {
        dispatch({
          ...defaultAction,
          type: "setNodeAccess",
          nodeAccess: result
        });
      };
      sendRequest({ uri: "/sa/nodes_access", camelize: true }, applyResult);
    }
  }, []);
  const showLoader =
    state.nodeAccess === null &&
    checkIfSllProductIntegrated(integratedProducts) &&
    !isAdminUser;

  function showContributorInsights() {
    return (
      state.nodeAccess &&
      !isAdminUser &&
      (state.nodeAccess.programs.length > 0 ||
        state.nodeAccess.institution.length > 0 ||
        state.nodeAccess.organizations.length > 0)
    );
  }
  return (
    <>
      {showContributorInsights() && (
        <div>
          <h2 className="heading">
            {translate("app.home.organizationProgramInsights")}
          </h2>
          <div className="desc">
            {translate("app.home.organizationProgramInsightsDesc")}
          </div>

          {state.nodeAccess && state.nodeAccess.institution.length > 0 && (
            <ContributorInstitutionInsights
              institution={state.nodeAccess.institution}
            />
          )}
          {state.nodeAccess &&
            state.nodeAccess.organizations.length > 0 && (
              <ContributorOrganizationInsights
                organizations={state.nodeAccess.organizations}
              />
            )}
          {state.nodeAccess &&
            state.nodeAccess.programs.length > 0 &&
            institution?.isSllSysAdminIntegrated && (
              <ContributorProgramInsights
                programs={state.nodeAccess.programs}
              />
            )}
        </div>
      )}
      {showLoader && (
        <div className="loader-height">
          <WidgetLoader
            loaderContainerClasses="loader"
            loaderClasses="content"
          />
        </div>
      )}
    </>
  );
}
